import { createGlobalStyle } from "styled-components";
import homeImage1 from "../assets/Images/Home1.jpg";
import homeImage2 from "../assets/Images/Home2.jpg";
import errorImage from "../assets/Images/Error.jpg";
import maintenanceImage from "../assets/Images/Maintenance.jpg";
import lightPodium from "../assets/Images/LightPodium.png";
import darkPodium from "../assets/Images/DarkPodium.png";

export const lightTheme = {
  body: "#ffffff",
  carousel: "#e9f4ff;",
  fontColor: "#101010",
  fontColor2: "#000000" /* Header text color without background */,
  fontColor3: "#e5e5e5" /* Header text color with background applied */,
  fontColor4: "#000000",
  fontColorHover: "#464646" /* Hyperlink hover */,
  borderColor: "#bfbfbf",
  backgroundNavbar: "rgb(14 19 24)",
  background1: "#f1f1f1" /* Background for the races module on the main page */,
  background2: "#f5f5f5" /* Background for the data module on the main page */,
  background3: "#1b1b1b" /* Background calendar */,
  background4: "#383838" /* Background calendar current day */,
  background5: "#1b1b1b" /* Background tooltip */,
  background6: "rgb(23 31 37)" /* Background top home */,
  homeImage1: `url(${homeImage1})`,
  homeImage2: `url(${homeImage2})`,
  errorImage: `url(${errorImage})`,
  maintenanceImage: `url(${maintenanceImage})`,
  colorLink: "#179387",
  colorLinkHover: "#36c7b9",
  colorOpacityRGBA: "52, 52, 52",
  faintEdge: "#d9d9d9", //For td tables
  green: "#31ab0a",
  red: "#d11717",
  orange: "#f57c00",
  backgroundGreen: "#58f1a3",
  backgroundRed: "#f44336",
  standingsCategories: "#dfdfdf",
  retColor: "#ce93d8",
  pointsColor: "#81c784",
  outofpointsColor: "#7986cb",
  winnerColor: "#fff176",
  winnerColorev: "#ffcb33",
  winnerColorev3: "#f2ae0a",
  secondColor: "#bdbdbd",
  secondColorev: "#858585",
  thirdColor: "#ffb74d",
  thirdColorev: "#f5792e",
  dnqColor: "#e57373",
  othersColor: "#f5f5f5",
  standingsBorder: "#c3c3c3",
  standingsBorder2: "#e1e1e1",
  emptyColor: "#f5f5f5",
  bonusColor: "#f06292",
  lightAColor: "#3c5250",
  darkAColor: "#179387",
  GreenAColor: "#317670",
  lightAColorHover: "#2c7a73",
  darkAColorHover: "#36c7b9",
  GreenAColorHover: "#3e9f96",
  resizeIcon:
    "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDE4Mi45MzEgMTgyLjkzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTgyLjkzMSAxODIuOTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBkPSJNMTczLjkzLDkyLjc5OGMtNC45NzEsMC05LDQuMDI5LTksOXY1MC40MDRMMzAuNzI4LDE4aDUwLjQwNGM0Ljk3MSwwLDktNC4wMjksOS05cy00LjAyOS05LTktOUg5QzQuMDMsMCwwLDQuMDI5LDAsOQ0KCXY3Mi4xMzJjMCw0Ljk3MSw0LjAyOSw5LDksOXM5LTQuMDI5LDktOVYzMC43MjlsMTM0LjIwMiwxMzQuMjAyaC01MC40MDRjLTQuOTcxLDAtOSw0LjAyOS05LDlzNC4wMjksOSw5LDloNzIuMTMyDQoJYzQuOTcxLDAsOS00LjAyOSw5LTl2LTcyLjEzMkMxODIuOTMsOTYuODI4LDE3OC45MDEsOTIuNzk4LDE3My45Myw5Mi43OTh6Ii8+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg==",
  backgroundRGB: "rgba(0,0,0,0.9);",
  podium: `url(${lightPodium})`,
  modal: "#ffffff",
  modalBorder: "#e3e3e3",
  svgDataTable: "rgb(223 223 223)",
  input: "#ffffff",
  datasearch: "#fbfbfb",
  racing1: "rgb(217, 217, 217)",
  racing2: "rgb(241, 241, 241)",
  hc1: "rgb(217, 217, 217)",
  hc2: "rgb(241, 241, 241)",
  ev1: "rgb(217, 217, 217)",
  ev2: "rgb(241, 241, 241)",
  headertb: "#e3e3e3",
  turqq: "#179387",
  close: `transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e") center/1em auto no-repeat !important;`,

  buttonBorder: `2px solid rgba(22, 145, 136, 0.45);`,
  buttonColor: `#158b84`,
  buttonHoverColor: `#0f6f69;`,
  buttonHoverBorder: `#19b6aa;`,
  buttonHoverBackground: `rgba(24, 198, 186, 0.08)`,
  buttonHoverBox: `0 6 20px rgba(24, 198, 186, 0.18);`,
  backgroundHCalendar: `#e1e1e1`,
  backgroundBordered: `#eeeeee`,
  tableHeader: `#eeeeee`,

  confirmButtonBorder: `2px solid rgba(46, 160, 67, 0.45)`,
  confirmButtonColor: `#2b8a3e`,
  confirmButtonHoverColor: `#1f6b2f`,
  confirmButtonHoverBorder: `#36b24d`,
  confirmButtonHoverBackground: `rgba(46, 160, 67, 0.08)`,
  confirmButtonHoverBox: `0 6px 20px rgba(46, 160, 67, 0.18)`,
  dangerButtonBorder: `2px solid rgba(220, 53, 69, 0.45)`,
  dangerButtonColor: `#c0392b`,
  dangerButtonHoverColor: `#a5281c`,
  dangerButtonHoverBorder: `#e14a57`,
  dangerButtonHoverBackground: `rgba(220, 53, 69, 0.08)`,
  dangerButtonHoverBox: `0 6px 20px rgba(220, 53, 69, 0.18)`,
  warningButtonBorder: `2px solid rgba(230, 146, 40, 0.45)`,
  warningButtonColor: `#c77712`,
  warningButtonHoverColor: `#a95f05`,
  warningButtonHoverBorder: `#f19a2a`,
  warningButtonHoverBackground: `rgba(230, 146, 40, 0.08)`,
  warningButtonHoverBox: `0 6px 20px rgba(230, 146, 40, 0.18)`,
  neutralButtonBorder: `2px solid rgba(108, 117, 125, 0.40)`,
  neutralButtonColor: `#5f6b76`,
  neutralButtonHoverColor: `#3d4750`,
  neutralButtonHoverBorder: `#7b8793`,
  neutralButtonHoverBackground: `rgba(108, 117, 125, 0.08)`,
  neutralButtonHoverBox: `0 6px 20px rgba(108, 117, 125, 0.16)`,

  neutralMainBorder: `2px solid rgba(60, 70, 80, 0.35)`,
  neutralMainColor: `#37424d`,
  neutralMainHoverColor: `#1f252b`,
  neutralMainHoverBorder: `#18c6ba`,
  neutralMainHoverBackground: `rgba(24, 198, 186, 0.08)`,
  neutralMainHoverBox: `0 8px 24px rgba(24, 198, 186, 0.18)`,
  selector1: "#ffffff",
  selector2: "#212529",
  selector3: "#ced4da",
  selector4: "#f8f9fa",
  selector5: "#212529",
  selector6: "#ced4da",
  selector7: "#3bd8c9",
  selector8: "#111",

  selector0: "#ffffff",
  selector10: "#212529",
  selector11: "#ced4da",
  selector12: "#3bd8c9",
  selector13: "#ffffff",
  selector14: "#212529",
  selector15: "#ced4da",
  selector16: "#3bd8c9",
  selector17: "#111",
  claimPenaltyCardBg: "#ffffff",
  claimPenaltyCardBorder: "#dce2e6",
  claimPenaltyCardBorderLeft: "#00b4a0",
  claimPenaltyCardHoverBg: "#f8f9fa",
  claimPenaltyCardHoverBorder: "#00b4a0",
  claimPenaltyNumberBg: "rgba(0, 180, 160, 0.05)",
  claimPenaltyNumberSpan: "#00b4a0",
  claimType: "#00b4a0",
  claimOffender: "#212529",
  claimPenaltyDetails: "#6c757d",
  claimDetailIcon: "#adb5bd",
  claimPenaltyStatusSpanBg: "rgba(220, 53, 69, 0.1)",
  claimPenaltyStatusSpanColor: "#dc3545",
  claimPenaltyStatusIcon: "#00b4a0",
  penaltyRowBg: "#f1f3f5",
  penaltyRowBorderLeft: "#dc3545",
  penaltyLabel: "#dc3545",
  penaltyText: "#212529",
  penaltyDescription: "#6c757d",
  directPenaltyBorderLeft: "#dc3545",
  directPenaltyNumberBg: "rgba(220, 53, 69, 0.05)",
  directPenaltyNumberSpan: "#dc3545",
  directPenaltyType: "#dc3545",
  claimPenaltyDescription: "#6c757d",
  claimPenaltyPointsDiv: "#dc3545",
  claimCardBg: "#ffffff",
  claimCardBorder: "#dce2e6",
  claimCardBorderLeft: "#00b4a0",
  claimCardHoverBg: "#f8f9fa",
  claimCardHoverBorder: "#00b4a0",
  claimCardHoverShadow: "rgba(0, 0, 0, 0.1)",
  claimCardNumberBg: "rgba(0, 180, 160, 0.05)",
  claimCardNumberBorderRight: "#dce2e6",
  claimCardNumberSpan: "#00b4a0",
  claimCardDriver: "#212529",
  claimCardMeta: "#6c757d",
  claimCardSessionBg: "#e9ecef",
  claimCardSessionColor: "#495057",
  claimCardDescription: "#495057",
  claimCardArrow: "#00b4a0",
  claimCardHoverArrow: "#212529",

  license1: "rgb(255 255 255 / 8%)",
  license2: "rgb(4 4 4 / 12%)",

  bgNewsPage: "#f8f9fa",
  colorNewsPage: "#212529",
  spanNewsHeaderTitle: "#00b4a0",
  pNewsHeaderTitle: "#6c757d",
  colorNewsCounter: "#495057",
  borderNewsSearchBox: "#ced4da",
  bgNewsSearchBox: "#ffffff",
  focusBorderNewsSearchBox: "#00b4a0",
  svgNewsSearchBox: "#6c757d",
  inputNewsSearchBox: "#212529",
  placeholderNewsSearchBox: "#adb5bd",
  borderNewsSearchButton: "#ced4da",
  colorNewsSearchButton: "#495057",
  hoverColorNewsSearchButton: "#00b4a0",
  hoverBgNewsSearchButton: "#e9ecef",
  borderNewsFilters: "#ced4da",
  bgNewsFilters: "#ffffff",
  labelNewsFilterField: "#495057",
  borderNewsFilterField: "#ced4da",
  bgNewsFilterField: "#ffffff",
  colorNewsFilterField: "#212529",
  focusBorderNewsFilterField: "#00b4a0",
  colorNewsCheckbox: "#212529",
  borderNewsCheckboxSpan: "#ced4da",
  checkedBorderNewsCheckboxSpan: "#00b4a0",
  checkedBgNewsCheckboxSpan: "#00b4a0",
  checkedAfterBorderNewsCheckboxSpan: "#ffffff",
  svgNewsDateInputs: "#6c757d",
  borderNewsFeatured: "#ced4da",
  bgNewsFeatured: "#ffffff",
  hoverBorderNewsFeatured: "#00b4a0",
  hoverShadowNewsFeatured: "rgba(0, 180, 160, 0.15)", // Sombra suave en tono turquesa para el hover
  overlayStartNewsFeatured: "rgba(0, 0, 0, 0.15)", // Oscuro al 75% donde va el texto
  overlayEndNewsFeatured: "rgba(0, 0, 0, 0.2)",
  bgNewsFeaturedLabel: "#00b4a0",
  colorNewsFeaturedLabel: "#ffffff",
  timeNewsFeaturedContent: "#6c757d",
  pNewsFeaturedContent: "#495057",
  borderNewsReadMore: "#00b4a0",
  colorNewsReadMore: "#00b4a0",
  hoverBgNewsReadMore: "#00b4a0",
  hoverColorNewsReadMore: "#ffffff",
  afterNewsSectionTitle: "#dee2e6",
  colorNewsSectionTitleDiv: "#212529",
  svgNewsSectionTitle: "#00b4a0",
  beforeNewsTimeline: "#ced4da",
  colorNewsTimelineDate: "#6c757d",
  bgNewsTimelinePointSpan: "#ffffff",
  shadowNewsTimelinePointSpan: "#00b4a0",
  borderNewsCard: "#dee2e6",
  bgNewsCard: "#ffffff",
  hoverBorderNewsCard: "#00b4a0",
  hoverBgNewsCard: "#f8f9fa",
  colorNewsCardMeta: "#6c757d",
  borderNewsCardCategory: "#ced4da",
  colorNewsCardCategory: "#495057",
  colorNewsCardContentH3: "#212529",
  colorNewsCardContentP: "#495057",
  colorNewsCardArrow: "#6c757d",
  hoverColorNewsCardArrow: "#00b4a0",
  borderPaginationPage: "#ced4da",
  bgPaginationPage: "#ffffff",
  colorPaginationPage: "#212529",
  hoverBorderPaginationPage: "#00b4a0",
  hoverColorPaginationPage: "#00b4a0",
  activeBorderPaginationPage: "#00b4a0",
  activeBgPaginationPage: "#00b4a0",
  activeColorPaginationPage: "#ffffff",
  colorPaginationEllipsis: "#6c757d",
  colorNewsEmpty: "#495057",
  svgNewsEmpty: "#adb5bd",
  colorNewsEmptyH2: "#212529",
  racesModalBg: "#ffffff",
  racesModalColor: "#212529",
  racesModalBorder: "rgba(23, 147, 135, 0.45)",
  racesModalShadow:
    "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 35px rgba(23, 147, 135, 0.08)",
  racesHeaderBg: "#f8f9fa",
  racesHeaderBorder: "#dee2e6",
  racesBodyGradient:
    "radial-gradient(circle at 80% 10%, rgba(23, 147, 135, 0.035), transparent 35%), #ffffff",
  racesSummaryBg: "#f8f9fa",
  racesSummaryBorder: "#dee2e6",
  racesSummaryDesc: "#6c757d",
  racesSummarySpan: "#6c757d",
  racesSummaryDivider: "#dee2e6",
  racesSummaryInfoColor: "#6c757d",
  racesContentHeaderSpan: "#6c757d",
  racesCardBg: "#ffffff",
  racesCardBorder: "#dee2e6",
  racesCardHoverBorder: "#179387",
  racesCardHoverShadow:
    "0 8px 25px rgba(0, 0, 0, 0.1), 0 0 15px rgba(23, 147, 135, 0.08)",
  racesCardImageBg: "#f1f3f5",
  racesCardImageOverlay:
    "linear-gradient(to top, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05) 60%)",
  racesArrowColor: "#179387",
  racesArrowBorder: "#179387",
  racesArrowBg: "rgba(240, 244, 248, 0.85)",
  racesArrowHoverBg: "#179387",
  racesArrowHoverColor: "#ffffff",
  racesScrollTrack: "#f1f3f5",
  racesScrollThumb: "#179387",
  racesScrollThumbHover: "#36c7b9",
  racesCircuitName: "#212529",
  racesCircuitBarBg: "rgba(0, 0, 0, 0.08)",
  racesCircuitBarFill: "#179387",
  racesCircuitPercentage: "#6c757d",
  transfersPickerBorder: "#179387",
  transfersPickerBg: "rgba(248, 249, 250, 0.85)",
  transfersPickerCountColor: "#179387",
  transfersPickerPosBg: "#179387",
  transfersPickerPosColor: "#ffffff",
  transfersTitleLineBg: "#179387",
  transfersCardBorder: "rgba(0, 0, 0, 0.1)",
  transfersCardBg:
    "linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(245, 247, 250, 0.95))",
  transfersCardHoverBorder: "rgba(23, 147, 135, 0.65)",
  transfersCardHoverShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
  transfersCardAccentBg: "#179387",
  transfersTeamNameColor: "#212529",
  transfersTeamNameHoverColor: "#179387",
  transfersDriverBg: "rgba(0, 0, 0, 0.035)",
  transfersEmptyBorder: "rgba(23, 147, 135, 0.25)",
  transfersEmptyBg: "rgba(23, 147, 135, 0.025)",
  transfersEmptyColor: "#6c757d",
  transfersEmptyIconBorder: "rgba(23, 147, 135, 0.35)",
  transfersEmptyIconColor: "#179387",
  transfersSignBtnBorder: "#179387",
  transfersSignBtnBg: "rgba(23, 147, 135, 0.12)",
  transfersSignBtnColor: "#179387",
  transfersSignBtnHoverBg: "#179387",
  transfersSignBtnHoverColor: "#ffffff",
  transfersCardFooterBorder: "rgba(0, 0, 0, 0.08)",
  transfersCardFooterColor: "#6c757d",
  transfersCardFooterStrongColor: "#212529",
  transfersCompleteColor: "#179387",
  transfersScrollThumbBg: "#179387",
  transfersScrollThumbHoverBg: "#36c7b9",
  weatherBackground: "#179387",
  weatherColor: "white",

  filter: `linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.8) 0%,
    rgba(255, 255, 255, 0.8) 100%
  );`,

  activeBack: "#f1f1f1",
  activeBorder: "#c3c3c3",

  backgroundLoad: "rgba(255, 255, 255, 0.7)",
};

export const darkTheme = {
  body: "#000000",
  carousel: "rgb(20 26 31)",
  fontColor: "rgb(205 205 205)",
  weatherColor: "rgb(205 205 205)",
  fontColor2: "#bfbfbf" /* Header text color without background */,
  fontColor3: "#e5e5e5" /* Header text color with background applied */,
  fontColor4: "#ffffff",
  fontColorHover: "#e5e5e5" /* Hyperlink hover */,
  borderColor: "transparent",
  backgroundNavbar: "rgb(14 18 24)",
  background1:
    "rgb(20 26 31)" /* Background for the races module on the main page */,
  background2: "#262626" /* Background for the data module on the main page */,
  background3: "#ffffff" /* Background calendar */,
  background4: "#f1f1f1" /* Background calendar current day */,
  background5: "#e7e7e7" /* Background tooltip */,
  background6: "rgb(23 31 37)" /* Background top home */,
  homeImage1: `url(${homeImage1})`,
  homeImage2: `url(${homeImage2})`,
  errorImage: `url(${errorImage})`,
  maintenanceImage: `url(${maintenanceImage})`,
  colorLink: "#3bd8c9",
  colorLinkHover: "#60eddf",
  colorOpacityRGBA: "255, 255, 255",
  faintEdge: "#3c3c3c", //For td tables
  green: "#51e54f",
  red: "#e14c4c",
  orange: "#ffa726",
  backgroundGreen: "#37af7d",
  backgroundRed: "#b71919",
  standingsCategories: "rgb(27 35 42)",
  weatherBackground: "rgb(27 35 42)",
  retColor: "#6a1b9a",
  pointsColor: "#2e7d32",
  outofpointsColor: "#283593",
  winnerColor: "#fbc02d",
  winnerColorev: "#fbc02d",
  winnerColorev3: "#fbc02d",
  secondColor: "#616161",
  secondColorev: "#a9a9a9",
  thirdColor: "#ef6c00",
  thirdColorev: "#ef6c00",
  dnqColor: "#c62828",
  othersColor: "rgb(21 27 33)",
  standingsBorder2: "rgb(45 51 57)",
  standingsBorder: "rgb(45 51 57)",
  emptyColor: "rgb(22 28 34)",
  bonusColor: "#d81b60",
  lightAColor: "#3bd8c9",
  darkAColor: "#317670",
  GreenAColor: "#a1c9c5",
  lightAColorHover: "#60eddf",
  darkAColorHover: "#569d96",
  GreenAColorHover: "#a2fff6",
  resizeIcon:
    "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSI+CjxnIGlkPSJzdXJmYWNlMSI+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDpyZ2IoMTAwJSwxMDAlLDEwMCUpO2ZpbGwtb3BhY2l0eToxOyIgZD0iTSAxMy4zMDQ2ODggNy4wOTc2NTYgQyAxMi45MjU3ODEgNy4wOTc2NTYgMTIuNjE3MTg4IDcuNDA2MjUgMTIuNjE3MTg4IDcuNzg5MDYyIEwgMTIuNjE3MTg4IDExLjY0NDUzMSBMIDIuMzUxNTYyIDEuMzc4OTA2IEwgNi4yMDcwMzEgMS4zNzg5MDYgQyA2LjU4NTkzOCAxLjM3ODkwNiA2Ljg5NDUzMSAxLjA3MDMxMiA2Ljg5NDUzMSAwLjY4NzUgQyA2Ljg5NDUzMSAwLjMwODU5NCA2LjU4NTkzOCAwIDYuMjA3MDMxIDAgTCAwLjY4NzUgMCBDIDAuMzA4NTk0IDAgMCAwLjMwODU5NCAwIDAuNjg3NSBMIDAgNi4yMDcwMzEgQyAwIDYuNTg1OTM4IDAuMzA4NTk0IDYuODk0NTMxIDAuNjg3NSA2Ljg5NDUzMSBDIDEuMDcwMzEyIDYuODk0NTMxIDEuMzc4OTA2IDYuNTg1OTM4IDEuMzc4OTA2IDYuMjA3MDMxIEwgMS4zNzg5MDYgMi4zNTE1NjIgTCAxMS42NDQ1MzEgMTIuNjE3MTg4IEwgNy43ODkwNjIgMTIuNjE3MTg4IEMgNy40MDYyNSAxMi42MTcxODggNy4wOTc2NTYgMTIuOTI1NzgxIDcuMDk3NjU2IDEzLjMwNDY4OCBDIDcuMDk3NjU2IDEzLjY4NzUgNy40MDYyNSAxMy45OTYwOTQgNy43ODkwNjIgMTMuOTk2MDk0IEwgMTMuMzA0Njg4IDEzLjk5NjA5NCBDIDEzLjY4NzUgMTMuOTk2MDk0IDEzLjk5NjA5NCAxMy42ODc1IDEzLjk5NjA5NCAxMy4zMDQ2ODggTCAxMy45OTYwOTQgNy43ODkwNjIgQyAxMy45OTYwOTQgNy40MDYyNSAxMy42ODc1IDcuMDk3NjU2IDEzLjMwNDY4OCA3LjA5NzY1NiBaIE0gMTMuMzA0Njg4IDcuMDk3NjU2ICIvPgo8L2c+Cjwvc3ZnPgo=",
  backgroundRGB: "rgba(255,255,255,0.9);",
  podium: `url(${darkPodium})`,
  modal: "#0e0e0e",
  modalBorder: "#424242",
  svgDataTable: "rgb(223 223 223)",
  input: "#3c4043",
  datasearch: "#35363a",
  racing1: "rgb(48 79 79)",
  racing2: "rgb(25 30 30)",
  hc1: "rgb(95 55 40)",
  hc2: "rgb(35 24 20)",
  ev1: "rgb(95 84 35)",
  ev2: "rgb(37 34 27)",
  headertb: "rgb(27 34 41)",
  turqq: "#3bd8c9 ",
  close: `transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e") center/1em auto no-repeat !important;`,

  buttonBorder: `2px solid rgba(24, 198, 186, 0.55)`,
  buttonColor: `#18c6ba`,
  buttonHoverColor: `white;`,
  buttonHoverBorder: `#22d8cb;`,
  buttonHoverBackground: `rgba(24, 198, 186, 0.08)`,
  buttonHoverBox: `0 0 18px rgba(24, 198, 186, 0.18);`,
  backgroundHCalendar: `#2c2c2c`,
  backgroundBordered: `rgb(23 31 37)`,
  tableHeader: `rgb(28 35 42)`,

  confirmButtonBorder: `2px solid rgba(74, 222, 128, 0.55)`,
  confirmButtonColor: `#4ade80`,
  confirmButtonHoverColor: `white`,
  confirmButtonHoverBorder: `#5ef18d`,
  confirmButtonHoverBackground: `rgba(74, 222, 128, 0.08)`,
  confirmButtonHoverBox: `0 0 18px rgba(74, 222, 128, 0.20)`,

  dangerButtonBorder: `2px solid rgba(248, 113, 113, 0.55)`,
  dangerButtonColor: `#f87171`,
  dangerButtonHoverColor: `white`,
  dangerButtonHoverBorder: `#ff8b8b`,
  dangerButtonHoverBackground: `rgba(248, 113, 113, 0.08)`,
  dangerButtonHoverBox: `0 0 18px rgba(248, 113, 113, 0.20)`,

  warningButtonBorder: `2px solid rgba(251, 191, 36, 0.55)`,
  warningButtonColor: `#fbbf24`,
  warningButtonHoverColor: `white`,
  warningButtonHoverBorder: `#ffd255`,
  warningButtonHoverBackground: `rgba(251, 191, 36, 0.08)`,
  warningButtonHoverBox: `0 0 18px rgba(251, 191, 36, 0.20)`,

  neutralButtonBorder: `2px solid rgba(180, 188, 196, 0.45)`,
  neutralButtonColor: `#c2c9d0`,
  neutralButtonHoverColor: `white`,
  neutralButtonHoverBorder: `#d7dde3`,
  neutralButtonHoverBackground: `rgba(180, 188, 196, 0.08)`,
  neutralButtonHoverBox: `0 0 18px rgba(180, 188, 196, 0.18)`,

  neutralMainBorderBorder: `2px solid rgba(74, 222, 128, 0.55)`,
  neutralMainBorderColor: `#4ade80`,
  neutralMainBorderHoverColor: `white`,
  neutralMainBorderHoverBorder: `#5ef18d`,
  neutralMainBorderHoverBackground: `rgba(74, 222, 128, 0.08)`,
  neutralMainBorderHoverBox: `0 0 18px rgba(74, 222, 128, 0.20)`,

  selector1: "rgb(22 28 34)",
  selector2: "#e8e8e8",
  selector3: "#3a3f44",
  selector4: "#30353a",
  selector5: "#f0f0f0",
  selector6: "#3a3f44",
  selector7: "#3bd8c9",
  selector8: "#111",
  selector9: "rgb(22 28 34)",
  selector10: "#e8e8e8",
  selector11: "#3a3f44",
  selector12: "#3bd8c9",
  selector13: "rgb(22 28 34)",
  selector14: "#e8e8e8",
  selector15: "#3a3f44",
  selector16: "#3bd8c9",
  selector17: "#111",

  claimPenaltyCardBg: "rgb(20 26 33)",
  claimPenaltyCardBorder: "#30363b",
  claimPenaltyCardBorderLeft: "#3bd8c9",
  claimPenaltyCardHoverBg: "#24292e",
  claimPenaltyCardHoverBorder: "#3bd8c9",
  claimPenaltyNumberBg: "rgba(59, 216, 201, 0.035)",
  claimPenaltyNumberSpan: "#3bd8c9",
  claimType: "#3bd8c9",
  claimOffender: "#f0f0f0",
  claimPenaltyDetails: "#9ba2a8",
  claimDetailIcon: "#6f777d",
  claimPenaltyStatusSpanBg: "rgba(190, 50, 50, 0.18)",
  claimPenaltyStatusSpanColor: "#ff6b6b",
  claimPenaltyStatusIcon: "#3bd8c9",
  penaltyRowBg: "#191d20",
  penaltyRowBorderLeft: "#ff5b5b",
  penaltyLabel: "#ff6b6b",
  penaltyText: "#f0f0f0",
  penaltyDescription: "#8f969c",
  directPenaltyBorderLeft: "#ff5b5b",
  directPenaltyNumberBg: "rgba(255, 91, 91, 0.035)",
  directPenaltyNumberSpan: "#ff6b6b",
  directPenaltyType: "#ff5b5b",
  claimPenaltyDescription: "#9ba2a8",
  claimPenaltyPointsDiv: "#ff6b6b",
  claimCardBg: "rgb(22 28 34)",
  claimCardBorder: "#30363b",
  claimCardBorderLeft: "#3bd8c9",
  claimCardHoverBg: "#24292e",
  claimCardHoverBorder: "#3bd8c9",
  claimCardHoverShadow: "rgba(0, 0, 0, 0.25)",
  claimCardNumberBg: "rgba(59, 216, 201, 0.035)",
  claimCardNumberBorderRight: "#30363b",
  claimCardNumberSpan: "#3bd8c9",
  claimCardDriver: "#f0f0f0",
  claimCardMeta: "#a1a8ad",
  claimCardSessionBg: "#30353a",
  claimCardSessionColor: "#cdd2d6",
  claimCardDescription: "#d0d4d7",
  claimCardArrow: "#3bd8c9",
  claimCardHoverArrow: "#ffffff",

  license1: "rgba(59, 216, 201, 0.08)",
  license2: "rgba(59, 216, 201, 0.12)",

  bgNewsPage: "#10161b",
  colorNewsPage: "#f0f0f0",
  spanNewsHeaderTitle: "#3bd8c9",
  pNewsHeaderTitle: "#b7bec3",
  colorNewsCounter: "#3bd8c9",
  borderNewsSearchBox: "#39434a",
  bgNewsSearchBox: "#151c21",
  focusBorderNewsSearchBox: "#3bd8c9",
  svgNewsSearchBox: "#aeb7bd",
  inputNewsSearchBox: "#f0f0f0",
  placeholderNewsSearchBox: "#778188",
  borderNewsSearchButton: "#39434a",
  colorNewsSearchButton: "#b9c0c5",
  hoverColorNewsSearchButton: "#3bd8c9",
  hoverBgNewsSearchButton: "rgba(59, 216, 201, 0.06)",
  borderNewsFilters: "#39434a",
  bgNewsFilters: "#151c21",
  labelNewsFilterField: "#aeb7bd",
  borderNewsFilterField: "#39434a",
  bgNewsFilterField: "#20282e",
  colorNewsFilterField: "#f0f0f0",
  focusBorderNewsFilterField: "#3bd8c9",
  colorNewsCheckbox: "#ddd",
  borderNewsCheckboxSpan: "#59636a",
  checkedBorderNewsCheckboxSpan: "#3bd8c9",
  checkedBgNewsCheckboxSpan: "#3bd8c9",
  checkedAfterBorderNewsCheckboxSpan: "#111",
  svgNewsDateInputs: "#3bd8c9",
  borderNewsFeatured: "#354149",
  bgNewsFeatured: "#11181d",
  hoverBorderNewsFeatured: "#3bd8c9",
  hoverShadowNewsFeatured: "rgba(0, 0, 0, 0.25)",
  overlayStartNewsFeatured: "transparent",
  overlayEndNewsFeatured: "rgba(17, 24, 29, 0.8)",
  bgNewsFeaturedLabel: "#3bd8c9",
  colorNewsFeaturedLabel: "#071012",
  timeNewsFeaturedContent: "#3bd8c9",
  pNewsFeaturedContent: "#b7c0c5",
  borderNewsReadMore: "#3bd8c9",
  colorNewsReadMore: "#3bd8c9",
  hoverBgNewsReadMore: "#3bd8c9",
  hoverColorNewsReadMore: "#10161b",
  afterNewsSectionTitle: "#3bd8c9",
  colorNewsSectionTitleDiv: "#f0f0f0",
  svgNewsSectionTitle: "#3bd8c9",
  beforeNewsTimeline: "#3bd8c9",
  colorNewsTimelineDate: "#f0f0f0",
  bgNewsTimelinePointSpan: "#3bd8c9",
  shadowNewsTimelinePointSpan: "#10161b",
  borderNewsCard: "#29353d",
  bgNewsCard: "#12191e",
  hoverBorderNewsCard: "#3bd8c9",
  hoverBgNewsCard: "#151f25",
  colorNewsCardMeta: "#8f9aa1",
  borderNewsCardCategory: "#3bd8c9",
  colorNewsCardCategory: "#3bd8c9",
  colorNewsCardContentH3: "#f0f0f0",
  colorNewsCardContentP: "#9fa9af",
  colorNewsCardArrow: "#8a959b",
  hoverColorNewsCardArrow: "#3bd8c9",
  borderPaginationPage: "#29353d",
  bgPaginationPage: "#12191e",
  colorPaginationPage: "#d7dcdf",
  hoverBorderPaginationPage: "#3bd8c9",
  hoverColorPaginationPage: "#3bd8c9",
  activeBorderPaginationPage: "#3bd8c9",
  activeBgPaginationPage: "rgba(59, 216, 201, 0.12)",
  activeColorPaginationPage: "#3bd8c9",
  colorPaginationEllipsis: "#8a959b",
  colorNewsEmpty: "#9fa9af",
  svgNewsEmpty: "#3bd8c9",
  colorNewsEmptyH2: "#f0f0f0",
  racesModalBg: "#0f1519",
  racesModalColor: "#eeeeee",
  racesModalBorder: "rgba(59, 216, 201, 0.45)",
  racesModalShadow:
    "0 20px 60px rgba(0, 0, 0, 0.65), 0 0 35px rgba(59, 216, 201, 0.08)",
  racesHeaderBg: "#10171b",
  racesHeaderBorder: "#283238",
  racesBodyGradient:
    "radial-gradient(circle at 80% 10%, rgba(59, 216, 201, 0.035), transparent 35%), #0f1519",
  racesSummaryBg: "#121a1f",
  racesSummaryBorder: "#26343a",
  racesSummaryDesc: "#9ba5aa",
  racesSummarySpan: "#8f999e",
  racesSummaryDivider: "#29353a",
  racesSummaryInfoColor: "#8f999e",
  racesContentHeaderSpan: "#7f898e",
  racesCardBg: "#131b20",
  racesCardBorder: "#29363b",
  racesCardHoverBorder: "#3bd8c9",
  racesCardHoverShadow:
    "0 8px 25px rgba(0, 0, 0, 0.35), 0 0 15px rgba(59, 216, 201, 0.08)",
  racesCardImageBg: "#0c1114",
  racesCardImageOverlay:
    "linear-gradient(to top, rgba(8, 12, 15, 0.8), rgba(8, 12, 15, 0.05) 60%)",
  racesArrowColor: "#3bd8c9",
  racesArrowBorder: "#3bd8c9",
  racesArrowBg: "rgba(10, 18, 21, 0.85)",
  racesArrowHoverBg: "#3bd8c9",
  racesArrowHoverColor: "#101619",
  racesScrollTrack: "#0c1114",
  racesScrollThumb: "#2a7771",
  racesScrollThumbHover: "#3bd8c9",
  racesCircuitName: "#ddd",
  racesCircuitBarBg: "rgba(255, 255, 255, 0.08)",
  racesCircuitBarFill: "#3bd8c9",
  racesCircuitPercentage: "#888",
  transfersPickerBorder: "#148f8c",
  transfersPickerBg: "rgba(10, 18, 22, 0.65)",
  transfersPickerCountColor: "#3bd8c9",
  transfersPickerPosBg: "#3bd8c9",
  transfersPickerPosColor: "#061113",
  transfersTitleLineBg: "#3bd8c9",
  transfersCardBorder: "rgba(120, 135, 145, 0.35)",
  transfersCardBg:
    "linear-gradient(145deg, rgba(25, 32, 37, 0.95), rgba(10, 17, 21, 0.95))",
  transfersCardHoverBorder: "rgba(59, 216, 201, 0.65)",
  transfersCardHoverShadow: "0 10px 30px rgba(0, 0, 0, 0.35)",
  transfersCardAccentBg: "#3bd8c9",
  transfersTeamNameColor: "#eeeeee",
  transfersTeamNameHoverColor: "#3bd8c9",
  transfersDriverBg: "rgba(255, 255, 255, 0.035)",
  transfersEmptyBorder: "rgba(59, 216, 201, 0.25)",
  transfersEmptyBg: "rgba(59, 216, 201, 0.025)",
  transfersEmptyColor: "#6f7e83",
  transfersEmptyIconBorder: "rgba(59, 216, 201, 0.35)",
  transfersEmptyIconColor: "#3bd8c9",
  transfersSignBtnBorder: "#35cfa8",
  transfersSignBtnBg: "rgba(53, 207, 168, 0.12)",
  transfersSignBtnColor: "#35d7ad",
  transfersSignBtnHoverBg: "#35cfa8",
  transfersSignBtnHoverColor: "#071311",
  transfersCardFooterBorder: "rgba(255, 255, 255, 0.08)",
  transfersCardFooterColor: "#77858a",
  transfersCardFooterStrongColor: "#dce4e5",
  transfersCompleteColor: "#35d7ad",
  transfersScrollThumbBg: "#198f8a",
  transfersScrollThumbHoverBg: "#3bd8c9",

  filter: `linear-gradient(
    135deg,
    rgba(18, 18, 18, 0.9) 0%,
    rgba(14, 18, 24, 0.9) 100%
  );`,

  activeBack: "#141a1f",
  activeBorder: "#344857",

  backgroundLoad: "rgba(20, 26, 31, 0.7);",
};

export const GlobalStyles = createGlobalStyle`
.dropdown-container-lt {
  color: ${(props: any) => props.theme.body};
}

.dropdown-container-lt > div {
  color: ${(props: any) => props.theme.fontColor};
  background-color: ${(props: any) => props.theme.background1};
}

.dropdown-container-lt > div a:hover {
  background-color: ${(props: any) => props.theme.turqq};
}

#drag-zone span:hover {
  background-color: ${(props: any) => props.theme.colorLink};
}
#last-gp-layout-container .mycanvas-container {
  background: ${(props: any) => props.theme.background} !important;
}

.data-standings .rdt_TableCell:first-child,
.data-standings .rdt_TableCell:last-child {
  background: ${(props: any) => props.theme.background1};
  color: ${(props: any) => props.theme.fontColor};
}

.data-standings .rdt_TableCell:not(:first-child):not(:last-child) {
  background: ${(props: any) => props.theme.emptyColor};
  color: ${(props: any) => props.theme.fontColor};
}
#main-image {
  background-image: ${(props: any) => props.theme.homeImage1};
}
#secondary-image {
  background-image: ${(props: any) => props.theme.homeImage2};
}
.form-check-input:focus {
  border: 1px solid ${(props: any) => props.theme.borderColor};
}
.navbar-fixed,
.dropdown-menu,
.dropdown-menu a:hover,
.dropdown-menu a:focus {
  background: ${(props: any) => props.theme.backgroundNavbar} !important;
}
.nextGP, .standings-title {
  background: ${(props: any) => props.theme.background6};
}

.nav-link, .navbar-brand, .categoryWrapper h1, .license-points  {
  color: ${(props: any) => props.theme.fontColor2} !important;
}
.categoryWrapper span:before, .categoryWrapper span:after, .categoryWrapper button, .categoryWrapper:hover button > span > span:before {
  border-color: ${(props: any) => props.theme.fontColor2} !important;
}
.categoryWrapper button > span > span > span:after {
  background: ${(props: any) => props.theme.fontColor2} !important;
  color: ${(props: any) => props.theme.body};
}

.categoryWrapper:hover button > span > span > span {
  color: ${(props: any) => props.theme.fontColor2};
}
.navbar-fixed a {
  color: ${(props: any) => props.theme.fontColor3} !important;
}
#main-races {
  background: ${(props: any) => props.theme.background1};
}
#main-data, #lastgp-standings {
  background: ${(props: any) => props.theme.background2};
  color: ${(props: any) => props.theme.fontColor};
}
.file-container > label:first-child, table tfoot,
.best-times-standings .rdt_TableCol,
#slot-absents p, #slot-unconf p
 {
  color: ${(props: any) => props.theme.fontColor};
  background: ${(props: any) => props.theme.tableHeader};
  border: 1px solid ${(props: any) => props.theme.standingsBorder};
}
#slot-absents, #slot-unconf {
  border: 1px solid ${(props: any) => props.theme.standingsBorder};
}
.driver-summary .rdt_TableHead div,
.rdt_Pagination,
.driver-summary-table-container .rdt_TableRow:last-child .rdt_TableCell {
  color: ${(props: any) => props.theme.background2};
  background: ${(props: any) => props.theme.fontColor} !important;
}
table thead th, table tfoot th, .control-panel > div:first-child{
  border: 1px solid ${(props: any) => props.theme.standingsBorder};
}
#secondary-image, .license-penalty-container > span a, .news-latest .dateFormat, .dropdown-container-lt .menu-icon {
  color: ${(props: any) => props.theme.fontColor};
}
#main-info {
  background: ${(props: any) => props.theme.background1};
  color: ${(props: any) => props.theme.fontColor};
}
#main-info p, .default-color {
  color: ${(props: any) => props.theme.fontColor};
}
#main-info span {
  color: ${(props: any) => props.theme.fontColor2};
}
#main-races p {
  color: ${(props: any) => props.theme.fontColor};
}
.race-report {
  background: ${(props: any) => props.theme.standingsCategories};
  color: ${(props: any) => props.theme.fontColor};
}
.react-calendar {
  background: ${(props: any) => props.theme.background2};
  color: ${(props: any) => props.theme.fontColor};
}
.update-claim {
  background: ${(props: any) => props.theme.backgroundRGB};
  color: ${(props: any) => props.theme.background1};
}
.react-calendar__month-view__weekdays {
  color: ${(props: any) => props.theme.fontColor};
}
.react-calendar__tile:not(.day-selected) abbr,
.react-calendar__tile:not(.day-selected-sec) abbr,
.react-calendar__tile:not(.day-selected-eve) abbr {
  color: ${(props: any) => props.theme.fontColor};
}
.react-calendar__tile--now::before {
  border: 4px solid ${(props: any) => props.theme.turqq} !important;
}

.news-item, .react-calendar, #general-news, #next-gp-standings > div, .dl-legend {
  border: 1px solid ${(props: any) => props.theme.standingsBorder};
  background: ${(props: any) => props.theme.backgroundBordered};
 }

.summary-results{
  border: 1px solid ${(props: any) => props.theme.standingsBorder};
 }
.standings-team
 {
  border: 1px solid ${(props: any) => props.theme.standingsBorder2};
}
input[type="text"], input[type="password"], input[type="date"], input[type="number"], input[type="file"] {
  border-color: ${(props: any) => props.theme.standingsBorder} !important;
}
  
.carousel-content {
  border-left: 4px solid ${(props: any) => props.theme.standingsBorder};
  border-right: 1px solid ${(props: any) => props.theme.standingsBorder};
}
.carousel-content h4 {
  background: ${(props: any) => props.theme.standingsBorder};
}
.driver {
  color: ${(props: any) => props.theme.colorLink};
}
.claim svg, 
#penalties-container svg,
#content-container a:not(.gp-driver-container a),
#last-gp-container a {
  color: ${(props: any) => props.theme.colorLink} !important;
}
.active-menu > a, .dropdown-menu a:hover, .dropdown-menu a:focus, a.active-menu {
  text-decoration-color: ${(props: any) => props.theme.colorLink} !important;
}
.driver:hover,
#content-container a:hover:not(.preseason a) {
  color: ${(props: any) => props.theme.colorLinkHover};
}
.white-driver {
  color: ${(props: any) => props.theme.fontColor2};
}
.full-white-driver, .full-white-driver:hover, #last-gp-container > div a {
  color: ${(props: any) => props.theme.fontColor4};
}
.white-driver:hover, .summary-results .fa-stopwatch {
  color: ${(props: any) => props.theme.fontColor};
}

.milestone-driver span{
  color: ${(props: any) => props.theme.fontColor2};
}

.scroll-button {
  background: rgba(${(props: any) => props.theme.colorOpacityRGBA}, 0.7);
  color: ${(props: any) => props.theme.body};
}

.scroll-button:hover {
  background: rgba(${(props: any) => props.theme.colorOpacityRGBA}, 1);
  color: ${(props: any) => props.theme.body};
}
.app-container, body, #last-gp-container > p {
  background: ${(props: any) => props.theme.background1};
  color: ${(props: any) => props.theme.fontColor};
}

.frame-turqoise .frame-title {
  background: ${(props: any) => props.theme.background1};
}

[data-tooltip]:after {
  background: ${(props: any) => props.theme.background5};
  color: ${(props: any) => props.theme.background1};
  border: black;
}
[data-tooltip][data-flow="top"]::before {
  border-top-color: ${(props: any) => props.theme.background5};
}
[data-tooltip][data-flow="left"]::before {
  border-left-color: ${(props: any) => props.theme.background5};
}
[data-tooltip][data-flow="right"]::before {
  border-right-color: ${(props: any) => props.theme.background5};
}
[data-tooltip][data-flow="bottom"]::before {
  border-bottom-color: ${(props: any) => props.theme.background5};
}
.table-stats-container .rdt_TableCol,
.table-stats-container .rdt_Pagination {
  background: ${(props: any) => props.theme.fontColor};
  color: ${(props: any) => props.theme.background1} !important;
}
.didyouknow2 {
  border-color: ${(props: any) => props.theme.fontColor};
}
@media (max-width: 991px) {
  .navbar {
    background: ${(props: any) => props.theme.backgroundNavbar} !important;
  }
}
#error-container {
  background-image: ${(props: any) => props.theme.errorImage};
}

#maintenance-container {
  background-image: ${(props: any) => props.theme.maintenanceImage};
}

.submenu-button {
  color: ${(props: any) => props.theme.fontColor2};
}

.submenu-button:hover {
  color: ${(props: any) => props.theme.fontColorHover};
}

.bottomBorder {
  border-bottom: 1px solid ${(props: any) => props.theme.fontColor};
}
.text-penalties-container, table thead, table tfoot {
  border: 1px solid ${(props: any) => props.theme.standingsBorder};
}
table td {
  border: 1px solid ${(props: any) => props.theme.faintEdge};
}

.team-table tbody, .team-delimiter {
  border-color: ${(props: any) => props.theme.faintEdge};
}

.green {
  color: ${(props: any) => props.theme.green} !important;
}
.red {
  color: ${(props: any) => props.theme.red} !important;
}
.orange {
  color: ${(props: any) => props.theme.orange} !important;
}
.button-green {
  background: ${(props: any) => props.theme.green} !important;
}
.button-red {
  background: ${(props: any) => props.theme.red} !important;
}
.button-orange {
  background: ${(props: any) => props.theme.orange} !important;
}
.button-green:hover {
  background: ${(props: any) => props.theme.green} !important;
}
.button-red:hover {
  background: ${(props: any) => props.theme.red} !important;
}
.button-orange:hover {
  background: ${(props: any) => props.theme.orange} !important;
}
.background-green {
  background: ${(props: any) => props.theme.backgroundGreen};
}
.background-red {
  background: ${(props: any) => props.theme.backgroundRed};
}
.checkmark {
  background-color: ${(props: any) => props.theme.fontColor3};
}

.standings-points, .standings-position, .results-position {
  background: ${(props: any) => props.theme.standingsCategories} !important;
  color: ${(props: any) => props.theme.fontColor} !important;
}
.hpRNJ {
  color: ${(props: any) => props.theme.fontColor};
  background: ${(props: any) => props.theme.background1};
}
.standings-Empty {
  background: ${(props: any) => props.theme.emptyColor} !important;
}
.standings-table thead, 
.standings-table tfoot, 
.standings-pos,
.standings-tab-points,
.data-standings .rdt_TableHead div,
.data-standings .rdt_TableRow > div:first-child,
.data-standings .rdt_TableRow .rdt_TableCell:last-child,
#live-timing-page .rdt_TableHead div,
#summary-nationalities .rdt_TableHead div,
#summary-nationalities > div:last-child nav,
#stats-data-container .rdt_TableHead div,
.modal-dialog .rdt_TableHead, 
.modal-dialog .rdt_Pagination, 
.modal-dialog .rdt_TableHead div, 
#stats-data-container div > div:last-child nav {
  background: ${(props: any) => props.theme.standingsCategories} !important;
  color: ${(props: any) => props.theme.fontColor} !important;
}


.standings-Ret {
  background: ${(props: any) => props.theme.retColor};
  color: ${(props: any) => props.theme.fontColor};
}

.standings-POINTS {
  background: ${(props: any) => props.theme.pointsColor};
  color: ${(props: any) => props.theme.fontColor};
}
.standings-OUT_OF_POINTS {
  background: ${(props: any) => props.theme.outofpointsColor};
  color: ${(props: any) => props.theme.fontColor};
}
.standings-BONUS {
  background: ${(props: any) => props.theme.bonusColor};
  color: ${(props: any) => props.theme.fontColor};
}
.standings-WINNER, .finalpos.p1 {
  background: ${(props: any) => props.theme.winnerColor};
}
.standings-SECOND, .finalpos.p2 {
  background: ${(props: any) => props.theme.secondColor};
  color: ${(props: any) => props.theme.fontColor};
}
.standings-THIRD, .finalpos.p3 {
  background: ${(props: any) => props.theme.thirdColor};
}
 
.finalposev.p1 {
  color: ${(props: any) => props.theme.winnerColorev};
}
.summary-results  svg  {
  color: ${(props: any) => props.theme.winnerColorev3};
}
.finalposev.p2 {
  color: ${(props: any) => props.theme.secondColorev};
}
.finalposev.p3 {
  color: ${(props: any) => props.theme.thirdColorev};
}
.standings-DNQ {
  background: ${(props: any) => props.theme.dnqColor};
}
.standings-Empty,
.standings-DNP,
.standings-DNS,
.standings-EX,
.standings-C,
.standings-INJ,
.driver-results .rdt_TableCell,
.driver-summary .rdt_TableCell,
#drivers-licenses .rdt_TableCell,
.table-stats-container .rdt_TableCell,
.historic-modal .rdt_TableCell,
#summary-nationalities .rdt_TableCell,
.livetiming-table-container .rdt_TableCell {
  background: ${(props: any) => props.theme.othersColor};
  color: ${(props: any) => props.theme.fontColor};
}

.standings-table td,
.standings-table thead,
.standings-table thead th,
.standings-table tfoot,
.standings-table tfoot th,
.react-resizable-handle {
  border: 1px solid ${(props: any) => props.theme.standingsBorder};
}

.rdt_TableRow .rdt_TableCell:last-child,
.rdt_TableHeadRow .rdt_TableCol:last-child,
.rdt_TableBody .rdt_TableRow:last-child,
.rdt_TableCol,
.rdt_TableCell,
.rdt_TableRow,
.rdt_TableHeadRow,
.driver-results .rdt_TableCell > div > div:not(:last-child),
.events-container > div,
#driver-entries-container > div,
#driver-entries-container,
#reserve-drivers-container > div,
#event-entries-drivers {
  border-color: ${(props: any) => props.theme.standingsBorder} !important;
} 

.standings-WINNER a,
.standings-THIRD a {
  color: ${(props: any) => props.theme.darkAColor};
}
.standings-WINNER a:hover,
.standings-THIRD a:hover {
  color: ${(props: any) => props.theme.darkAColorHover};
}

.standings-OUT_OF_POINTS a {
  color: ${(props: any) => props.theme.lightAColor};
}
.standings-OUT_OF_POINTS a:hover {
  color: ${(props: any) => props.theme.lightAColorHover};
}
.standings-POINTS a {
  color: ${(props: any) => props.theme.GreenAColor};
}
.standings-POINTS a:hover {
  color: ${(props: any) => props.theme.GreenAColorHover};
}
.checker {
  fill: ${(props: any) => props.theme.fontColor};
}
.react-resizable-handle {
  background-image: url("${(props: any) => props.theme.resizeIcon}");
}

.update-claim .btn-outline-primary {
  color: ${(props: any) => props.theme.background1};
  border-color: ${(props: any) => props.theme.background1};
}
.update-claim .btn-outline-primary:hover {
  background: ${(props: any) => props.theme.background1};
  color: ${(props: any) => props.theme.fontColor};
}

.claim-penalty > b {
  color: ${(props: any) => props.theme.background2};
  background: ${(props: any) => props.theme.fontColor};
}

.claim-penalty {
  border: 2px solid ${(props: any) => props.theme.fontColor};
}

.podium-container {
  background-image: ${(props: any) => props.theme.podium};
}
.modal-content {
  background: ${(props: any) => props.theme.modal};
  border: 1px solid ${(props: any) => props.theme.modalBorder};
  color: ${(props: any) => props.theme.fontColor};
}
.modal-footer, .modal-header { 
  border-color: ${(props: any) => props.theme.modalBorder};
}
.sc-ezWOiH button {
  fill: ${(props: any) => props.theme.svgDataTable};
}
.dropdown-dates p:hover {
  background: ${(props: any) => props.theme.green};
}
.round-calendar {
  color: ${(props: any) => props.theme.body};
  background-color: ${(props: any) => props.theme.fontColor4};
}

#datesearch {
  background: ${(props: any) => props.theme.datasearch} !important;
}

.pagination button {
  background: ${(props: any) => props.theme.datasearch} !important;
  color: ${(props: any) => props.theme.fontColor4} !important;
}

.question-parent path, .question-parent circle {
  fill: ${(props: any) => props.theme.fontColorHover} !important;
}
.driver-card, .row-stats .bordered, .longstat, .events-container .bordered {
  border: 1px solid ${(props: any) => props.theme.faintEdge};
}
 
.events-container > a > .flex:last-child {
  border-top: 1px solid ${(props: any) => props.theme.faintEdge};
}
.driver-card.f1-results {
  border: 1px solid ${(props: any) => props.theme.racing1} !important;
  background-color: ${(props: any) => props.theme.racing2} !important;
}
.hc-results {
  margin-bottom: 15px;
  border: 1px solid ${(props: any) => props.theme.hc1} !important;
  background-color: ${(props: any) => props.theme.hc2} !important;
}
.event-results {
  border: 1px solid ${(props: any) => props.theme.ev1} !important;
  background-color: ${(props: any) => props.theme.ev2} !important;
}

.driver-results .rdt_TableHead div {
  background: ${(props: any) => props.theme.headertb} !important;
  color: ${(props: any) => props.theme.fontColor4} !important;
}
.event-info > *, .event-val {
  color: ${(props: any) => props.theme.fontColor4};
}
.driver-title,
.btn-ver-mas.cir {
  color: ${(props: any) => props.theme.colorLink};
}
 
.categoryWrapper button > span > span > span {
  color: ${(props: any) => props.theme.fontColor};
}

.btn-close {
  background: ${(props: any) => props.theme.close} !important;
}

.frame-turqoise {
  border-top: 2px solid ${(props: any) => props.theme.turqq};
  border-right: 2px solid ${(props: any) => props.theme.turqq};
}
#index-gp-container .main-title,
.post-race-container .main-title,
.standings-title svg,
#gp-title svg,
.milestones-data svg,
#claim-form .main-title,
#claims-container .main-title,
.gp-incidents-container .news-item .frame-title  {
  color: ${(props: any) => props.theme.turqq};
}
.news-item .category, 
.slick-next::before,
.slick-next::before,
.slick-prev::before  {
  color: ${(props: any) => props.theme.turqq} !important;
}
.button-lvf1 {
  border: ${(props: any) => props.theme.buttonBorder};
  color: ${(props: any) => props.theme.buttonColor};
}
.button-lvf1:hover {
  color: ${(props: any) => props.theme.buttonHoverColor};
  border-color: ${(props: any) => props.theme.buttonHoverBorder};
  background: ${(props: any) => props.theme.buttonHoverBackground};
  box-shadow: ${(props: any) => props.theme.buttonHoverBox};
}
.react-calendar__navigation > button {
  color: ${(props: any) => props.theme.turqq} !important;
}
.react-calendar__navigation > button:hover {
  color: ${(props: any) => props.theme.background6} !important;
}
 
.react-calendar__navigation > button:focus,
.react-calendar__tile:hover,
.react-calendar__navigation button:enabled:hover, 
.react-calendar__navigation button:enabled:focus {
  background-color: ${(props: any) => props.theme.turqq} !important;
}
.backgrounded-title {
  background-color: ${(props: any) => props.theme.turqq} !important;
  color: ${(props: any) => props.theme.body} !important;
}
.button-green-lvf1 {
  border: ${(props: any) => props.theme.confirmButtonBorder};
  color: ${(props: any) => props.theme.confirmButtonColor};
}

.button-green-lvf1:hover {
  color: ${(props: any) => props.theme.confirmButtonHoverColor};
  border-color: ${(props: any) => props.theme.confirmButtonHoverBorder};
  background: ${(props: any) => props.theme.confirmButtonHoverBackground};
  box-shadow: ${(props: any) => props.theme.confirmButtonHoverBox};
}

.button-red-lvf1 {
  border: ${(props: any) => props.theme.dangerButtonBorder};
  color: ${(props: any) => props.theme.dangerButtonColor};
}

.button-red-lvf1:hover {
  color: ${(props: any) => props.theme.dangerButtonHoverColor};
  border-color: ${(props: any) => props.theme.dangerButtonHoverBorder};
  background: ${(props: any) => props.theme.dangerButtonHoverBackground};
  box-shadow: ${(props: any) => props.theme.dangerButtonHoverBox};
}

.button-orange-lvf1 {
  border: ${(props: any) => props.theme.warningButtonBorder};
  color: ${(props: any) => props.theme.warningButtonColor};
}

.button-orange-lvf1:hover {
  color: ${(props: any) => props.theme.warningButtonHoverColor};
  border-color: ${(props: any) => props.theme.warningButtonHoverBorder};
  background: ${(props: any) => props.theme.warningButtonHoverBackground};
  box-shadow: ${(props: any) => props.theme.warningButtonHoverBox};
}

.button-neutral-lvf1 {
  border: ${(props: any) => props.theme.neutralButtonBorder};
  color: ${(props: any) => props.theme.neutralButtonColor};
}

.button-neutral-lvf1:hover {
  color: ${(props: any) => props.theme.neutralButtonHoverColor};
  border-color: ${(props: any) => props.theme.neutralButtonHoverBorder};
  background: ${(props: any) => props.theme.neutralButtonHoverBackground};
  box-shadow: ${(props: any) => props.theme.neutralButtonHoverBox};
}
  #main-inner-text {
  color: ${(props: any) => props.theme.background5};
}


.button-main-lvf1 {
  border: ${(props: any) => props.theme.neutralMainBorder};
  color: ${(props: any) => props.theme.neutralMainColor};
}

.button-main-lvf1:hover {
  color: ${(props: any) => props.theme.neutralMainHoverColor};
  border-color: ${(props: any) => props.theme.neutralMainHoverBorder};
  background: ${(props: any) => props.theme.neutralMainHoverBackground};
  box-shadow: ${(props: any) => props.theme.neutralMainHoverBox};
}

input[type="file"].form-control {
  background-color: ${(props: any) => props.theme.selector1} !important;
  color: ${(props: any) => props.theme.selector2} !important;
  border-color: ${(props: any) => props.theme.selector3} !important;
}

/* Botón "Seleccionar archivo" */
input[type="file"].form-control::file-selector-button {
  background-color: ${(props: any) => props.theme.selector4} !important;
  color: ${(props: any) => props.theme.selector5} !important;
  border: none;
  border-right: 1px solid ${(props: any) => props.theme.selector6} !important;
  padding: 0.375rem 0.75rem;
  margin-right: 0.75rem;
}

/* Hover del botón */
input[type="file"].form-control::file-selector-button:hover {
  background-color:${(props: any) => props.theme.selector7} !important;
  color: ${(props: any) => props.theme.selector8} !important;
}
select.form-select, select.form-control {
  background-color: ${(props: any) => props.theme.selector1} !important;
  color: ${(props: any) => props.theme.selector2} !important;
  border-color: ${(props: any) => props.theme.selector3} !important;
}

/* Opciones del desplegable */
select.form-select option, select.form-control option {
  background-color: ${(props: any) => props.theme.selector1};
  color: ${(props: any) => props.theme.selector2};
}

/* Cuando está seleccionado/en foco */
select.form-select:focus, select.form-select:focus, select.form-control:focus, select.form-control:focus {
  background-color: ${(props: any) => props.theme.selector1};
  color: ${(props: any) => props.theme.selector2};
  border-color: ${(props: any) => props.theme.selector7};
  box-shadow: 0 0 0 0.2rem rgba(59, 216, 201, 0.15);
}
  input.form-control,
textarea.form-control,
.bg-white.border, .bg-light
 {
  background-color: ${(props: any) => props.theme.selector1} !important;
  color: ${(props: any) => props.theme.selector2} !important;
  border-color: ${(props: any) => props.theme.selector3} !important;
}

/* Placeholder */
input.form-control::placeholder,
textarea.form-control::placeholder {
  color: #8b9298 !important;
  opacity: 1 !important;
}

/* Cuando está seleccionado */
input.form-control:focus,
textarea.form-control:focus {
  background-color: ${(props: any) => props.theme.selector13} !important;
  color: ${(props: any) => props.theme.selector14} !important;
  border-color: ${(props: any) => props.theme.selector15} !important;
  box-shadow: 0 0 0 0.2rem rgba(59, 216, 201, 0.15) !important;
}

/* Texto seleccionado */
input.form-control::selection,
textarea.form-control::selection {
  background-color: ${(props: any) => props.theme.selector16} !important;
  color: ${(props: any) => props.theme.selector17} !important;
}



#drivers-licenses .rdt_TableCol, table thead, .control-panel > div:first-child {
  background-color: ${(props: any) => props.theme.tableHeader};
  color: ${(props: any) => props.theme.fontColor};
 }

 
.submenu-selected {
  border-bottom: 2px solid ${(props: any) => props.theme.turqq};
  color: ${(props: any) => props.theme.turqq};
}
  
.claim-penalty-card .pending {
  color: ${(props: any) => props.theme.turqq};
}

.claim-penalty-card {
  background: ${(props: any) => props.theme.claimPenaltyCardBg};
  border: 1px solid ${(props: any) => props.theme.claimPenaltyCardBorder};
  border-left: 3px solid ${(props: any) => props.theme.claimPenaltyCardBorderLeft};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.claim-penalty-card:hover {
  background: ${(props: any) => props.theme.claimPenaltyCardHoverBg};
  border-color: ${(props: any) => props.theme.claimPenaltyCardHoverBorder};
}

.claim-penalty-number {
  background: ${(props: any) => props.theme.claimPenaltyNumberBg};
}

.claim-penalty-number span {
  color: ${(props: any) => props.theme.claimPenaltyNumberSpan};
}

.claim-type {
  color: ${(props: any) => props.theme.claimType};
}

.claim-offender {
  color: ${(props: any) => props.theme.claimOffender};
}

.claim-penalty-details {
  color: ${(props: any) => props.theme.claimPenaltyDetails};
}

.claim-detail i {
  color: ${(props: any) => props.theme.claimDetailIcon};
}

.claim-penalty-status span {
  background: ${(props: any) => props.theme.claimPenaltyStatusSpanBg};
  color: ${(props: any) => props.theme.claimPenaltyStatusSpanColor};
}

.claim-penalty-status i {
  color: ${(props: any) => props.theme.claimPenaltyStatusIcon};
}

.penalty-row {
  background: ${(props: any) => props.theme.penaltyRowBg};
  border-left: 2px solid ${(props: any) => props.theme.penaltyRowBorderLeft};
}

.penalty-label {
  color: ${(props: any) => props.theme.penaltyLabel};
}

.penalty-text {
  color: ${(props: any) => props.theme.penaltyText};
}

.penalty-description {
  color: ${(props: any) => props.theme.penaltyDescription};
}

.direct-penalty {
  border-left-color: ${(props: any) => props.theme.directPenaltyBorderLeft};
}

.direct-penalty .claim-penalty-number {
  background: ${(props: any) => props.theme.directPenaltyNumberBg};
}

.direct-penalty .claim-penalty-number span {
  color: ${(props: any) => props.theme.directPenaltyNumberSpan};
}

.direct-penalty .claim-type {
  color: ${(props: any) => props.theme.directPenaltyType};
}

.claim-penalty-description {
  color: ${(props: any) => props.theme.claimPenaltyDescription};
}

.claim-penalty-points > div {
  color: ${(props: any) => props.theme.claimPenaltyPointsDiv};
}

.claim-card {
  background: ${(props: any) => props.theme.claimCardBg};
  border: 1px solid ${(props: any) => props.theme.claimCardBorder};
  border-left: 3px solid ${(props: any) => props.theme.claimCardBorderLeft};
}

.claim-card:hover {
  background: ${(props: any) => props.theme.claimCardHoverBg};
  border-color: ${(props: any) => props.theme.claimCardHoverBorder};
  box-shadow: 0 4px 15px ${(props: any) => props.theme.claimCardHoverShadow};
}

.claim-card-number {
  background: ${(props: any) => props.theme.claimCardNumberBg};
  border-right: 1px solid ${(props: any) => props.theme.claimCardNumberBorderRight};
}

.claim-card-number span {
  color: ${(props: any) => props.theme.claimCardNumberSpan};
}

.claim-card-driver {
  color: ${(props: any) => props.theme.claimCardDriver};
}

.claim-card-meta {
  color: ${(props: any) => props.theme.claimCardMeta};
}

.claim-card-session {
  background: ${(props: any) => props.theme.claimCardSessionBg};
  color: ${(props: any) => props.theme.claimCardSessionColor};
}

.claim-card-description {
  color: ${(props: any) => props.theme.claimCardDescription};
}

.claim-card-arrow {
  color: ${(props: any) => props.theme.claimCardArrow};
}

.claim-card:hover .claim-card-arrow {
  color: ${(props: any) => props.theme.claimCardHoverArrow};
}
.license-points, .lpoints {
  background: ${(props: any) => props.theme.license1};
  border: 1px solid ${(props: any) => props.theme.license2};
}


.news-checkbox input:checked + span,
.news-featured-label,
.news-section-title::after,
.news-timeline::before,
.news-timeline-point span,
.news-read-more:hover  {
  background: ${(props: any) => props.theme.turqq};
}

.news-header-title h1 span,
.news-counter,
.news-search-button:hover,
.news-filter-button:hover,
.news-filter-button.active,
.news-date-inputs svg,
.news-featured-content > time,
.news-featured-content > span + span,
.news-section-title svg,
.news-card-category,
.news-timeline-item:hover .news-card-arrow,
.pagination-page:hover,
.pagination-arrow:hover:not(:disabled),
.pagination-page.active,
.news-empty svg,
.news-read-more,
.rally-lock
{
  color: ${(props: any) => props.theme.turqq};
}
.news-search-box:focus-within,
.news-checkbox input:checked + span,
.news-filter-field select:focus,
.news-featured:hover,
.news-filter-field input[type="date"]:focus,
.news-timeline-item:hover .news-card,
.pagination-page.active,
.pagination-page.active,
.pagination-page:hover,
.pagination-arrow:hover:not(:disabled)
 {
  border-color: ${(props: any) => props.theme.turqq};
}
  
.news-card-category,
.news-read-more,
.rally-lock
 {
  border: 1px solid ${(props: any) => props.theme.turqq};
}
.news-featured {
  background: ${(props: any) => props.theme.newsFeatured};
}
  /* =========================================================
   NEWS PAGE
========================================================= */

.news-page {
  background: ${(props: any) => props.theme.bgNewsPage};
  color: ${(props: any) => props.theme.colorNewsPage};
}

.news-header-title h1 span {
  color: ${(props: any) => props.theme.spanNewsHeaderTitle};
}

.news-header-title p {
  color: ${(props: any) => props.theme.pNewsHeaderTitle};
}

.news-counter {
  color: ${(props: any) => props.theme.colorNewsCounter};
}

/* =========================================================
   SEARCH
========================================================= */

.news-search-box {
  border: 1px solid ${(props: any) => props.theme.borderNewsSearchBox};
  background: ${(props: any) => props.theme.bgNewsSearchBox};
}

.news-search-box:focus-within {
  border-color: ${(props: any) => props.theme.focusBorderNewsSearchBox};
}

.news-search-box > svg {
  color: ${(props: any) => props.theme.svgNewsSearchBox};
}

.news-search-box input {
  color: ${(props: any) => props.theme.inputNewsSearchBox};
}

.news-search-box input::placeholder {
  color: ${(props: any) => props.theme.placeholderNewsSearchBox};
}

.news-search-button,
.news-filter-button {
  border-left: 1px solid ${(props: any) => props.theme.borderNewsSearchButton};
  color: ${(props: any) => props.theme.colorNewsSearchButton};
}

.news-search-button:hover,
.news-filter-button:hover,
.news-filter-button.active {
  color: ${(props: any) => props.theme.hoverColorNewsSearchButton};
  background: ${(props: any) => props.theme.hoverBgNewsSearchButton};
}

/* =========================================================
   FILTERS
========================================================= */

.news-filters {
  border: 1px solid ${(props: any) => props.theme.borderNewsFilters};
  background: ${(props: any) => props.theme.bgNewsFilters};
}

.news-filter-field > label {
  color: ${(props: any) => props.theme.labelNewsFilterField};
}

.news-filter-field select,
.news-filter-field input[type="date"] {
  border: 1px solid ${(props: any) => props.theme.borderNewsFilterField};
  background: ${(props: any) => props.theme.bgNewsFilterField};
  color: ${(props: any) => props.theme.colorNewsFilterField};
}

.news-filter-field select:focus,
.news-filter-field input[type="date"]:focus {
  border-color: ${(props: any) => props.theme.focusBorderNewsFilterField};
}

.news-checkbox {
  color: ${(props: any) => props.theme.colorNewsCheckbox} !important;
}

.news-checkbox span {
  border: 1px solid ${(props: any) => props.theme.borderNewsCheckboxSpan};
}

.news-checkbox input:checked + span {
  border-color: ${(props: any) => props.theme.checkedBorderNewsCheckboxSpan};
  background: ${(props: any) => props.theme.checkedBgNewsCheckboxSpan};
}

.news-checkbox input:checked + span::after {
  border-right: 2px solid ${(props: any) => props.theme.checkedAfterBorderNewsCheckboxSpan};
  border-bottom: 2px solid ${(props: any) => props.theme.checkedAfterBorderNewsCheckboxSpan};
}

.news-date-inputs svg {
  color: ${(props: any) => props.theme.svgNewsDateInputs};
}

/* =========================================================
   FEATURED
========================================================= */

.news-featured {
  border: 1px solid ${(props: any) => props.theme.borderNewsFeatured};
  background: ${(props: any) => props.theme.bgNewsFeatured};
}

.news-featured:hover {
  border-color: ${(props: any) => props.theme.hoverBorderNewsFeatured};
  box-shadow: 0 10px 35px ${(props: any) => props.theme.hoverShadowNewsFeatured};
}

.news-featured-overlay {
  background: linear-gradient(
    90deg,
    ${(props: any) => props.theme.overlayStartNewsFeatured} 60%,
    ${(props: any) => props.theme.overlayEndNewsFeatured}
  );
}

.news-featured-label {
  background: ${(props: any) => props.theme.bgNewsFeaturedLabel};
  color: ${(props: any) => props.theme.colorNewsFeaturedLabel};
}

.news-featured-content > time,
.news-featured-content > span + span {
  color: ${(props: any) => props.theme.timeNewsFeaturedContent};
}

.news-featured-content p {
  color: ${(props: any) => props.theme.pNewsFeaturedContent};
}

.news-read-more {
  border: 1px solid ${(props: any) => props.theme.borderNewsReadMore};
  color: ${(props: any) => props.theme.colorNewsReadMore};
}

.news-read-more:hover {
  background: ${(props: any) => props.theme.hoverBgNewsReadMore};
  color: ${(props: any) => props.theme.hoverColorNewsReadMore};
}

/* =========================================================
   SECTION TITLE
========================================================= */

.news-section-title::after {
  background: ${(props: any) => props.theme.afterNewsSectionTitle};
}

.news-section-title > div {
  color: ${(props: any) => props.theme.colorNewsSectionTitleDiv};
}

.news-section-title svg {
  color: ${(props: any) => props.theme.svgNewsSectionTitle};
}

/* =========================================================
   TIMELINE
========================================================= */

.news-timeline-date {
  color: ${(props: any) => props.theme.colorNewsTimelineDate};
}
.news-card {
  border: 1px solid ${(props: any) => props.theme.borderNewsCard};
  background: ${(props: any) => props.theme.bgNewsCard};
}

.news-timeline-item:hover .news-card {
  border-color: ${(props: any) => props.theme.hoverBorderNewsCard};
  background: ${(props: any) => props.theme.hoverBgNewsCard};
}

.news-card-meta {
  color: ${(props: any) => props.theme.colorNewsCardMeta};
}

.news-card-category {
  border: 1px solid ${(props: any) => props.theme.borderNewsCardCategory};
  color: ${(props: any) => props.theme.colorNewsCardCategory};
}

.news-card-content h3 {
  color: ${(props: any) => props.theme.colorNewsCardContentH3};
}

.news-card-content p {
  color: ${(props: any) => props.theme.colorNewsCardContentP};
}

.news-card-arrow {
  color: ${(props: any) => props.theme.colorNewsCardArrow};
}

.news-timeline-item:hover .news-card-arrow {
  color: ${(props: any) => props.theme.hoverColorNewsCardArrow};
}

/* =========================================================
   PAGINATION
========================================================= */

.pagination-page,
.pagination-arrow {
  border: 1px solid ${(props: any) => props.theme.borderPaginationPage};
  background: ${(props: any) => props.theme.bgPaginationPage};
  color: ${(props: any) => props.theme.colorPaginationPage};
}

.pagination-page:hover,
.pagination-arrow:hover:not(:disabled) {
  border-color: ${(props: any) => props.theme.hoverBorderPaginationPage};
  color: ${(props: any) => props.theme.hoverColorPaginationPage};
}

.pagination-page.active {
  border-color: ${(props: any) => props.theme.activeBorderPaginationPage};
  background: ${(props: any) => props.theme.activeBgPaginationPage};
  color: ${(props: any) => props.theme.activeColorPaginationPage};
}

.pagination-ellipsis {
  color: ${(props: any) => props.theme.colorPaginationEllipsis};
}

/* =========================================================
   EMPTY
========================================================= */

.news-empty {
  color: ${(props: any) => props.theme.colorNewsEmpty};
}

.news-empty svg {
  color: ${(props: any) => props.theme.svgNewsEmpty};
}

.news-empty h2 {
  color: ${(props: any) => props.theme.colorNewsEmptyH2};
}
.news-featured,
.news-card {
  border-color: ${(props: any) => props.theme.standingsBorder};
}
/* Color cuando la opción está seleccionada o activa */
select option:checked,
select option:hover {
  background-color: ${(props: any) => props.theme.turqq} !important; /* Tu color turquesa */
  color: ${(props: any) => props.theme.body} !important;
}
.races-country-modal .modal-content,#picker-list {
  background: ${(props: any) => props.theme.racesModalBg};
  color: ${(props: any) => props.theme.racesModalColor};
  border: 1px solid ${(props: any) => props.theme.racesModalBorder};
  box-shadow: ${(props: any) => props.theme.racesModalShadow};
}

.races-country-modal .modal-header {
  border-bottom: 1px solid ${(props: any) => props.theme.racesHeaderBorder};
  background: ${(props: any) => props.theme.racesHeaderBg};
}

.races-modal-country-header span,
.country-races-total strong,
.country-circuits-total strong {
  color: ${(props: any) => props.theme.turqq};
}

.races-country-modal .modal-body {
  background: ${(props: any) => props.theme.racesBodyGradient};
}

.country-summary-card {
  border: 1px solid ${(props: any) => props.theme.racesSummaryBorder};
  background: ${(props: any) => props.theme.racesSummaryBg};
}

.country-summary-card::before,
.country-summary-card h3 strong {
  background: ${(props: any) => props.theme.turqq};
}

.country-summary-description,
.race-country-card-date .dateFormat {
  color: ${(props: any) => props.theme.racesSummaryDesc};
}

.country-races-total span,
.country-circuits-total span,
.country-summary-info {
  color: ${(props: any) => props.theme.racesSummaryInfoColor};
}

.country-summary-divider {
  background: ${(props: any) => props.theme.racesSummaryDivider};
}

.country-summary-info strong,
.races-country-content-header h3,
.race-country-card-info h4 {
  color: ${(props: any) => props.theme.racesModalColor};
}

.races-country-content-header span {
  color: ${(props: any) => props.theme.racesContentHeaderSpan};
}

.race-country-card {
  background: ${(props: any) => props.theme.racesCardBg};
  border: 1px solid ${(props: any) => props.theme.racesCardBorder};
}

.race-country-card:hover {
  border-color: ${(props: any) => props.theme.racesCardHoverBorder};
  box-shadow: ${(props: any) => props.theme.racesCardHoverShadow};
}

.race-country-image {
  background: ${(props: any) => props.theme.racesCardImageBg};
}

.race-country-image-overlay {
  background: ${(props: any) => props.theme.racesCardImageOverlay};
}

.race-country-arrow {
  color: ${(props: any) => props.theme.racesArrowColor};
  border: 1px solid ${(props: any) => props.theme.racesArrowBorder};
  background: ${(props: any) => props.theme.racesArrowBg};
}

.race-country-card:hover .race-country-arrow {
  background: ${(props: any) => props.theme.racesArrowHoverBg};
  color: ${(props: any) => props.theme.racesArrowHoverColor};
}

.races-country-modal .modal-body::-webkit-scrollbar-track {
  background: ${(props: any) => props.theme.racesScrollTrack};
}

.races-country-modal .modal-body::-webkit-scrollbar-thumb {
  background: ${(props: any) => props.theme.racesScrollThumb};
}

.races-country-modal .modal-body::-webkit-scrollbar-thumb:hover {
  background: ${(props: any) => props.theme.racesScrollThumbHover};
}

.country-circuit-name {
  color: ${(props: any) => props.theme.racesCircuitName};
}

.country-circuit-count {
  color: ${(props: any) => props.theme.turqq};
}

.country-circuit-bar {
  background: ${(props: any) => props.theme.racesCircuitBarBg};
}

.country-circuit-bar-fill {
  background: ${(props: any) => props.theme.racesCircuitBarFill};
}

.country-circuit-percentage {
  color: ${(props: any) => props.theme.racesCircuitPercentage};
}
  #picker-list {
  border: 1px solid ${(props: any) => props.theme.transfersPickerBorder};
  background: ${(props: any) => props.theme.transfersPickerBg};
}

.picker-count {
  color: ${(props: any) => props.theme.transfersPickerCountColor};
}

.picker-position {
  background: ${(props: any) => props.theme.transfersPickerPosBg};
  color: ${(props: any) => props.theme.transfersPickerPosColor};
}

.teams-title-line {
  background: ${(props: any) => props.theme.transfersTitleLineBg};
}

.team-card {
  border: 1px solid ${(props: any) => props.theme.transfersCardBorder};
  background: ${(props: any) => props.theme.transfersCardBg};
}

.team-card:hover {
  border-color: ${(props: any) => props.theme.transfersCardHoverBorder};
  box-shadow: ${(props: any) => props.theme.transfersCardHoverShadow};
}

.team-card-accent {
  background: ${(props: any) => props.theme.transfersCardAccentBg};
}

.team-name {
  color: ${(props: any) => props.theme.transfersTeamNameColor};
}

.team-name:hover {
  color: ${(props: any) => props.theme.transfersTeamNameHoverColor};
}

.team-driver {
  background: ${(props: any) => props.theme.transfersDriverBg};
}

.team-driver-empty {
  border: 1px dashed ${(props: any) => props.theme.transfersEmptyBorder};
  background: ${(props: any) => props.theme.transfersEmptyBg};
}

.empty-driver {
  color: ${(props: any) => props.theme.transfersEmptyColor};
}

.empty-driver-icon {
  border: 1px solid ${(props: any) => props.theme.transfersEmptyIconBorder};
  color: ${(props: any) => props.theme.transfersEmptyIconColor};
}

.button-sign-team,
.sign-button {
  border: 1px solid ${(props: any) => props.theme.transfersSignBtnBorder} !important;
  background: ${(props: any) => props.theme.transfersSignBtnBg} !important;
  color: ${(props: any) => props.theme.transfersSignBtnColor} !important;
}

.button-sign-team:hover {
  background: ${(props: any) => props.theme.transfersSignBtnHoverBg} !important;
  color: ${(props: any) => props.theme.transfersSignBtnHoverColor} !important;
}

.team-card-footer {
  border-top: 1px solid ${(props: any) => props.theme.transfersCardFooterBorder};
  color: ${(props: any) => props.theme.transfersCardFooterColor};
}

.team-card-footer strong {
  color: ${(props: any) => props.theme.transfersCardFooterStrongColor};
}

.team-complete {
  color: ${(props: any) => props.theme.transfersCompleteColor};
}

.picker-drivers::-webkit-scrollbar-thumb {
  background: ${(props: any) => props.theme.transfersScrollThumbBg};
}

.picker-drivers::-webkit-scrollbar-thumb:hover {
  background: ${(props: any) => props.theme.transfersScrollThumbHoverBg};
}
.rw-container-main {
  background: ${(props: any) => props.theme.weatherBackground} !important;
  color: ${(props: any) => props.theme.weatherColor} !important;
}
  
#driver-entries-container a {
  color: ${(props: any) => props.theme.fontColor} !important;
}
.livetiming-table-container .rdt_Table, 
.livetiming-table-container .rdt_Table div:not(.logo-results-container) {
  color: ${(props: any) => props.theme.fontColor};
  background: ${(props: any) => props.theme.backgroundBordered};
}
.filter-color::after {
  background: ${(props: any) => props.theme.filter};
}

.home-container #main-data {
  background: ${(props: any) => props.theme.backgroundBordered};
}
.carousel-root {
  background: ${(props: any) => props.theme.carousel};
}
.carousel-root span, .carousel-root small, .carousel-root label {
  color: ${(props: any) => props.theme.fontColor};
}
.countdown-days, .timeline-containerstandings {
  border-color: ${(props: any) => props.theme.standingsBorder}
}
.gp-flags > div.active {
  background-color: ${(props: any) => props.theme.activeBack};
  border: 1px solid ${(props: any) => props.theme.activeBorder};
}
.gp-flags > div {
  background-color: ${(props: any) => props.theme.activeBack};
}
.timeline-container .height-100 {
  background-color: ${(props: any) => props.theme.backgroundLoad};
}
.timeline-container .height-100 svg {
  color: ${(props: any) => props.theme.fontColor} !important;
}
.text-muted {
  color: ${(props: any) => props.theme.fontColorHover} !important;
}
`;
